import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isIOS } from '../utils/utils';
import { storeLinks } from '../utils/constants';

const DownloadDriverPage = () => {
  useEffect(() => {
    const isIOSDevice = isIOS();
    window.location.assign(isIOSDevice ? storeLinks.apple.driver : storeLinks.android.driver);
  }, []);

  return <Navigate to='/' />;
};

export default DownloadDriverPage;
